import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import BackButton from '../../components/BackButton';
import RateLimitModal from '../../components/RateLimitModal';
import api from '../../services/api';
import './UtilityPage.css';

const UuidGenerator = () => {
  const { isAuthenticated } = useAuth();
  const [uuids, setUuids] = useState([]);
  const [error, setError] = useState('');
  const [showRateLimitModal, setShowRateLimitModal] = useState(false);
  const [rateLimitError, setRateLimitError] = useState(null);

  const handleGenerate = async () => {
    try {
      setError('');
      const response = await api.get('/api/utilities/uuid/generate');
      setUuids([...uuids, response.data.uuid]);
    } catch (err) {
      if (err.response?.status === 429) {
        const errorData = err.response.data;
        setRateLimitError({
          message: errorData.message || 'Rate limit exceeded',
          isAuthenticated: errorData.isAuthenticated !== undefined ? errorData.isAuthenticated : isAuthenticated,
          suggestion: errorData.suggestion || '',
          currentLimit: errorData.currentLimit || '',
          loginLimit: errorData.loginLimit || '',
          premiumLimit: errorData.premiumLimit || ''
        });
        setShowRateLimitModal(true);
      } else {
        setError(err.response?.data?.error || 'Failed to generate UUID');
      }
    }
  };

  const handleClear = () => {
    setUuids([]);
  };

  return (
    <div className="utility-page">
      <BackButton />
      <div className="utility-container">
        <h1>UUID Generator</h1>
        <div className="utility-form">
          <button onClick={handleGenerate} className="btn-process">Generate UUID</button>
          {error && <div className="error-message">{error}</div>}
          {uuids.length > 0 && (
            <div className="output-section">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
                <label>Generated UUIDs</label>
                <button onClick={handleClear} className="btn-clear">Clear</button>
              </div>
              <div className="uuid-list">
                {uuids.map((uuid, index) => (
                  <div key={index} className="uuid-item">
                    <code>{uuid}</code>
                    <button
                      onClick={() => navigator.clipboard.writeText(uuid)}
                      className="btn-copy"
                    >
                      Copy
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
      
      {showRateLimitModal && rateLimitError && (
        <RateLimitModal 
          error={rateLimitError}
          onClose={() => {
            setShowRateLimitModal(false);
            setRateLimitError(null);
          }}
        />
      )}
    </div>
  );
};

export default UuidGenerator;

